import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, Col } from "reactstrap";

const FanDemoGraphics = ({ labels = [], series, type, size }) => {
  const [chartWidth, setChartWidth] = useState(
    window.innerWidth >= 1200
      ? 800
      : window.innerWidth >= 992
      ? 700
      : window.innerWidth > 768
      ? 400
      : 250
  );

  useEffect(() => {
    let timeout;
    const handleResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setChartWidth(window.innerWidth > 768 ? 420 : 250);
      }, 200);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const validSeries =
    Array.isArray(series) && series.length > 0 ? series : null;
  const validLabels =
    Array.isArray(labels) && labels.length === series?.length
      ? labels
      : validSeries?.map((_, i) => `Label ${i + 1}`) || [];

  const options = {
    chart: { type: "pie" },
    labels: validLabels,
    legend: { position: "bottom" },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: { width: "100%" },
          legend: { position: "bottom" }
        }
      }
    ]
  };

  return (
    <Col xl={size} md="10" className="mb-4">
      <Card className="d-flex w-100 py-2">
        <h3 className="text-center mt-2">{type}</h3>
        <div id="chart" className="d-flex justify-content-center">
          {validSeries ? (
            <ReactApexChart
              options={options}
              series={validSeries}
              type="pie"
              width={chartWidth}
            />
          ) : (
            <p className="text-center">Loading chart...</p>
          )}
        </div>
      </Card>
    </Col>
  );
};

export default FanDemoGraphics;
